import React, { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";

import { useDialogState } from "../../../hooks/useDialogState";
import { useProfileState } from "../../../hooks/useProfileState";

import { useSharedListStyles } from "../../../shared/useSharedListStyles";

import ProfilesListView from "./ProfilesListView";

import BimProfileService from "../../../services/BimProfileService";

import LoadingIndicator from "../../../shared/LoadingIndicator";
import {trackPromise} from "react-promise-tracker";
import UserService from "../../../services/UserService";
import {useNavigate} from "react-router-dom";
import {buildRealmPath} from "../../../shared/routing";


function BimProfiles() {
    const token = useSelector((state) => state.keycloakToken);
    const realm = useSelector((state) => state.theRealm);
    const profileCtx = useProfileState();
    const bimProf = profileCtx.profiles;
    const setBimProf = profileCtx.setProfiles;
    const dialogCtx = useDialogState();
    const setBIMDialogOpen = dialogCtx.setBimOpen;
    const bimProfileSelected = profileCtx.selected;
    const setBimProfileSelected = profileCtx.setSelected;
    const setBimProfileSelectedData = profileCtx.setSelectedData;

    const classes = useSharedListStyles();
    const navigate = useNavigate();

    useEffect(() => {
        if (!UserService.isLoggedIn()) {
            UserService.doLogout();
        }
    }, []);

    const GetProfilesData = useCallback(async () => {
        try {
            const res = await BimProfileService.getBimProfiles(token, realm);
            if (res.data?.result) {
                setBimProf(res.data.result);
            } else {
                setBimProf(res.data ?? []);
            }
            setBimProfileSelected('');
            setBimProfileSelectedData([]);
        } catch (e) {
            console.error("Fehler beim Laden der Profile:", e);
        }
    }, [setBimProf, setBimProfileSelected, setBimProfileSelectedData, realm, token]);

    useEffect(() => {
        if (!bimProf || bimProf.length === 0) {
            trackPromise(GetProfilesData());
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const addNew = () => {
        setBimProfileSelected("");
        setBimProfileSelectedData([]);
        setBIMDialogOpen(true);
    };

    const showBimetaProfiles = () => {
        navigate(buildRealmPath(realm, '/BimProfile/bimetaprofile'));
    };

    return (
        <div>
            <LoadingIndicator />
            <div className={classes.katalogView}>
                <div className={classes.btListe}>
                    <ProfilesListView
                        profileList={bimProf}
                        GetProfilesData={GetProfilesData}
                        setBimProfileSelected={setBimProfileSelected}
                        bimProfileSelected={bimProfileSelected}
                        addNew={addNew}
                        showBimetaProfiles={showBimetaProfiles}
                    />
                </div>
            </div>
        </div>
    );
}

export default BimProfiles;